export default "__VITE_ASSET__DfyOek1u__"